export class RouletteRacetrackConfiguration {
    //******************************************************************************************************************
    //  Sizes used to generate HTML racetrack
    //******************************************************************************************************************

    public static RacetrackWidth: number;
    public static RacetrackHeight: number;
    public static SingleWidth: number;
    public static SingleHeight: number;
    public static TiersWidth: number;
    public static OrphelinsWidth: number;
    public static VoisinsWidth: number;
    public static ZeroGameWidth: number;
    public static MiddleHeight: number;
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/RouletteRacetrackConfiguration.ts
 **/